export const ERRORS = {
    UNAUTHORIZED: { code: 'UNAUTHORIZED', status: 401, message: 'Authentication required' },
    TOKEN_EXPIRED: { code: 'TOKEN_EXPIRED', status: 401, message: 'Token has expired' },
    TOKEN_INVALID: { code: 'TOKEN_INVALID', status: 401, message: 'Invalid token provided' },
    SESSION_EXPIRED: { code: 'SESSION_EXPIRED', status: 401, message: 'Session has expired' },
    AUTHENTICATION_REQUIRED: { code: 'AUTHENTICATION_REQUIRED', status: 401, message: 'Authentication required' },
    INVALID_OTP: { code: 'INVALID_OTP', status: 401, message: 'Invalid OTP code' },
    OTP_EXPIRED: { code: 'OTP_EXPIRED', status: 401, message: 'OTP code has expired' },
    PHONE_NUMBER_NOT_FOUND: { code: 'PHONE_NUMBER_NOT_FOUND', status: 401, message: 'Phone number not found' },
    TOTP_UNAUTHORIZED: { code: 'TOTP_UNAUTHORIZED', status: 401, message: 'TOTP authentication failed' },
    PIN_INVALID: { code: 'PIN_INVALID', status: 401, message: 'Invalid PIN' },
    PIN_NOT_SET: { code: 'PIN_NOT_SET', status: 403, message: 'PIN not set' },
    PIN_ATTEMPTS_EXCEEDED: { code: 'PIN_ATTEMPTS_EXCEEDED', status: 423, message: 'PIN attempts exceeded' },
    PIN_LOCKED: { code: 'PIN_LOCKED', status: 423, message: 'PIN is locked' },
    PIN_REQUIRED: { code: 'PIN_REQUIRED', status: 428, message: 'PIN confirmation required' },
    PIN_TOO_WEAK: { code: 'PIN_TOO_WEAK', status: 400, message: 'PIN must be exactly 6 digits' },
    PIN_ALREADY_SET: { code: 'PIN_ALREADY_SET', status: 409, message: 'PIN already set' },
    FORBIDDEN: { code: 'FORBIDDEN', status: 403, message: 'Forbidden' },
    ACCOUNT_SUSPENDED: { code: 'ACCOUNT_SUSPENDED', status: 403, message: 'Account is suspended' },
    SMS_BLOCKED_DESTINATION: {
        code: 'SMS_BLOCKED_DESTINATION',
        status: 403,
        message: 'SMS delivery blocked for this destination',
    },
    USER_NAME_UPDATE_NOT_ALLOWED: {
        code: 'USER_NAME_UPDATE_NOT_ALLOWED',
        status: 403,
        message: 'User name can only be updated when status is PENDING_VERIFICATION',
    },
    SIGNUP_DISABLED: {
        code: 'SIGNUP_DISABLED',
        status: 403,
        message: 'New user registration is currently disabled',
    },
    APP_VERSION_TOO_LOW: {
        code: 'APP_VERSION_TOO_LOW',
        status: 403,
        message: 'Please update your app to the latest version to continue',
    },
    RESOURCE_NOT_FOUND: { code: 'RESOURCE_NOT_FOUND', status: 404, message: 'Resource not found' },
    USER_NOT_FOUND: { code: 'USER_NOT_FOUND', status: 404, message: 'User not found' },
    CARD_NOT_FOUND: { code: 'CARD_NOT_FOUND', status: 404, message: 'Card not found' },
    NOT_FOUND: { code: 'NOT_FOUND', status: 404, message: 'Not found' },
    EMAIL_VERIFICATION_CODE_NOT_FOUND: {
        code: 'EMAIL_VERIFICATION_CODE_NOT_FOUND',
        status: 404,
        message: 'No verification code is active. Please request a new one',
    },
    NOTIFICATION_NOT_FOUND: {
        code: 'NOTIFICATION_NOT_FOUND',
        status: 404,
        message: 'Notification not found',
    },
    NOTIFICATION_BANNER_NOT_FOUND: {
        code: 'NOTIFICATION_BANNER_NOT_FOUND',
        status: 404,
        message: 'Notification banner not found',
    },
    NOTIFICATION_TYPE_NOT_FOUND: {
        code: 'NOTIFICATION_TYPE_NOT_FOUND',
        status: 404,
        message: 'Notification type not found',
    },
    NOTIFICATION_TYPE_CANNOT_ENABLE: {
        code: 'NOTIFICATION_TYPE_CANNOT_ENABLE',
        status: 400,
        message: 'This notification type cannot be enabled',
    },
    VALIDATION_ERROR: { code: 'VALIDATION_ERROR', status: 400, message: 'Validation error' },
    INVALID_INPUT: { code: 'INVALID_INPUT', status: 400, message: 'Invalid input' },
    INVALID_REQUEST: { code: 'INVALID_REQUEST', status: 400, message: 'Invalid request' },
    MISSING_FIELD: { code: 'MISSING_FIELD', status: 400, message: 'Missing required field' },
    INVALID_FORMAT: { code: 'INVALID_FORMAT', status: 400, message: 'Invalid format' },
    INVALID_ADDRESS: { code: 'INVALID_ADDRESS', status: 400, message: 'Invalid address' },
    INVALID_ACCOUNT: { code: 'INVALID_ACCOUNT', status: 400, message: 'Invalid account' },
    INVALID_STATUS: { code: 'INVALID_STATUS', status: 400, message: 'Invalid status' },
    INVALID_AGREEMENT_PROVIDER: {
        code: 'INVALID_AGREEMENT_PROVIDER',
        status: 400,
        message: 'Invalid agreement provider',
    },
    INVALID_AGREEMENT_VERSION: {
        code: 'INVALID_AGREEMENT_VERSION',
        status: 400,
        message: 'Invalid agreement version',
    },
    SMS_INVALID_PHONE_NUMBER: { code: 'SMS_INVALID_PHONE_NUMBER', status: 400, message: 'Invalid phone number format' },
    INVALID_DELIVERY_MODE: {
        code: 'INVALID_DELIVERY_MODE',
        status: 400,
        message: 'Invalid delivery mode specified',
    },
    INVALID_USER_DATA: {
        code: 'INVALID_USER_DATA',
        status: 400,
        message: 'Invalid or incomplete user data',
    },
    EMAIL_VERIFICATION_CODE_INVALID: {
        code: 'EMAIL_VERIFICATION_CODE_INVALID',
        status: 400,
        message: 'That code is not correct. Please check the latest email from mygate',
    },
    EMAIL_VERIFICATION_CODE_EXPIRED: {
        code: 'EMAIL_VERIFICATION_CODE_EXPIRED',
        status: 400,
        message: 'This code has expired. Please request a new one',
    },
    EMAIL_VERIFICATION_TOO_MANY_ATTEMPTS: {
        code: 'EMAIL_VERIFICATION_TOO_MANY_ATTEMPTS',
        status: 429,
        message: 'Too many incorrect attempts. Please request a new code',
    },
    EMAIL_VERIFICATION_TOO_MANY_REQUESTS: {
        code: 'EMAIL_VERIFICATION_TOO_MANY_REQUESTS',
        status: 429,
        message: 'Too many verification emails requested. Please try again later',
    },
    ALREADY_EXISTS: { code: 'ALREADY_EXISTS', status: 409, message: 'Already exists' },
    USER_ALREADY_EXISTS: { code: 'USER_ALREADY_EXISTS', status: 409, message: 'User already exists' },
    EMAIL_ALREADY_CONFIRMED: { code: 'EMAIL_ALREADY_CONFIRMED', status: 409, message: 'Email is already confirmed' },
    EMAIL_ALREADY_VERIFIED: { code: 'EMAIL_ALREADY_VERIFIED', status: 409, message: 'Email is already verified' },
    DELETION_ALREADY_REQUESTED: {
        code: 'DELETION_ALREADY_REQUESTED',
        status: 409,
        message: 'Account deletion already requested',
    },
    AGREEMENT_ALREADY_ACCEPTED: {
        code: 'AGREEMENT_ALREADY_ACCEPTED',
        status: 409,
        message: 'Agreement has already been accepted and cannot be modified',
    },
    EARLY_ACCESS_ALREADY_REGISTERED: {
        code: 'EARLY_ACCESS_ALREADY_REGISTERED',
        status: 409,
        message: 'You are already registered for this feature',
    },
    EARLY_ACCESS_NOT_FOUND: {
        code: 'EARLY_ACCESS_NOT_FOUND',
        status: 404,
        message: 'Early access registration not found',
    },
    RATE_LIMIT_EXCEEDED: { code: 'RATE_LIMIT_EXCEEDED', status: 429, message: 'Rate limit exceeded' },
    OTP_MAX_ATTEMPTS: { code: 'OTP_MAX_ATTEMPTS', status: 429, message: 'Maximum OTP attempts exceeded' },
    SMS_RATE_LIMIT_EXCEEDED: {
        code: 'SMS_RATE_LIMIT_EXCEEDED',
        status: 429,
        message: 'SMS rate limit exceeded. Please try again later.',
    },
    SMS_INSUFFICIENT_BALANCE: {
        code: 'SMS_INSUFFICIENT_BALANCE',
        status: 402,
        message: 'Insufficient SMS provider balance',
    },
    INSUFFICIENT_FUNDS: { code: 'INSUFFICIENT_FUNDS', status: 422, message: 'Insufficient funds' },
    LIMIT_EXCEEDED: { code: 'LIMIT_EXCEEDED', status: 422, message: 'Limit exceeded' },
    KYC_REQUIRED: { code: 'KYC_REQUIRED', status: 422, message: 'KYC verification required' },
    KYC_PENDING: { code: 'KYC_PENDING', status: 422, message: 'KYC verification pending' },
    KYC_REJECTED: { code: 'KYC_REJECTED', status: 422, message: 'KYC verification rejected' },
    KYC_EXPIRED: { code: 'KYC_EXPIRED', status: 422, message: 'KYC verification expired' },
    SMS_CONTENT_REJECTED: { code: 'SMS_CONTENT_REJECTED', status: 422, message: 'SMS content rejected by provider' },
    KYC_INVALID_STATUS_FOR_RETRY: {
        code: 'KYC_INVALID_STATUS_FOR_RETRY',
        status: 422,
        message: 'KYC case cannot be retried in current status',
    },
    KYC_ALREADY_VERIFIED: {
        code: 'KYC_ALREADY_VERIFIED',
        status: 409,
        message: 'User already has a successful KYC verification',
    },
    KYC_CASE_IN_PROGRESS: {
        code: 'KYC_CASE_IN_PROGRESS',
        status: 409,
        message: 'User already has a KYC case in progress',
    },
    KYC_EXTRACTION_PENDING: {
        code: 'KYC_EXTRACTION_PENDING',
        status: 409,
        message: 'KYC verification completed but data extraction is pending',
    },
    INTERNAL_ERROR: { code: 'INTERNAL_ERROR', status: 500, message: 'Internal server error' },
    OPERATION_FAILED: { code: 'OPERATION_FAILED', status: 500, message: 'Operation failed' },
    OTP_SEND_FAILED: { code: 'OTP_SEND_FAILED', status: 500, message: 'Failed to send OTP' },
    EMAIL_SEND_FAILED: { code: 'EMAIL_SEND_FAILED', status: 500, message: 'Failed to send email' },
    SERVICE_UNAVAILABLE: { code: 'SERVICE_UNAVAILABLE', status: 503, message: 'Service temporarily unavailable' },
    EMAIL_SERVICE_UNAVAILABLE: {
        code: 'EMAIL_SERVICE_UNAVAILABLE',
        status: 503,
        message: 'Email service temporarily unavailable',
    },
    SMS_PROVIDER_UNAVAILABLE: {
        code: 'SMS_PROVIDER_UNAVAILABLE',
        status: 503,
        message: 'SMS service temporarily unavailable',
    },
    SMS_CONFIGURATION_ERROR: {
        code: 'SMS_CONFIGURATION_ERROR',
        status: 500,
        message: 'SMS provider configuration error',
    },
    PAYCENTER_API_ERROR: { code: 'PAYCENTER_API_ERROR', status: 502, message: 'PayCenter service unavailable' },
    PAYCENTER_INVALID_CUSTOMER: {
        code: 'PAYCENTER_INVALID_CUSTOMER',
        status: 400,
        message: 'Invalid PayCenter customer ID',
    },
    PAYCENTER_AUTHENTICATION_FAILED: {
        code: 'PAYCENTER_AUTHENTICATION_FAILED',
        status: 401,
        message: 'PayCenter authentication failed',
    },
    PAYCENTER_ACCOUNT_NOT_FOUND: {
        code: 'PAYCENTER_ACCOUNT_NOT_FOUND',
        status: 404,
        message: 'PayCenter account not found',
    },
    PAYCENTER_CARD_NOT_FOUND: {
        code: 'PAYCENTER_CARD_NOT_FOUND',
        status: 404,
        message: 'PayCenter card not found',
    },
    PAYCENTER_ENCRYPTION_FAILED: {
        code: 'PAYCENTER_ENCRYPTION_FAILED',
        status: 500,
        message: 'PayCenter encryption failed',
    },
    PAYCENTER_DECRYPTION_FAILED: {
        code: 'PAYCENTER_DECRYPTION_FAILED',
        status: 500,
        message: 'PayCenter decryption failed',
    },
    PAYCENTER_RATE_LIMIT: { code: 'PAYCENTER_RATE_LIMIT', status: 429, message: 'PayCenter rate limit exceeded' },
    PAYCENTER_TRANSACTION_FAILED: {
        code: 'PAYCENTER_TRANSACTION_FAILED',
        status: 400,
        message: 'PayCenter transaction execution failed',
    },
    PAYCENTER_TRANSACTION_NOT_ALLOWED: {
        code: 'PAYCENTER_TRANSACTION_NOT_ALLOWED',
        status: 422,
        message: 'PayCenter declined the transfer',
    },
    PAYCENTER_CARD_ORDER_FAILED: {
        code: 'PAYCENTER_CARD_ORDER_FAILED',
        status: 500,
        message: 'Failed to order physical card',
    },
    PAYCENTER_CARD_REORDER_FAILED: {
        code: 'PAYCENTER_CARD_REORDER_FAILED',
        status: 500,
        message: 'Failed to reorder card',
    },
    CARD_REORDER_IN_PROGRESS: {
        code: 'CARD_REORDER_IN_PROGRESS',
        status: 409,
        message: 'A card reorder is already in progress',
    },
    CARD_REORDER_TOO_RECENT: {
        code: 'CARD_REORDER_TOO_RECENT',
        status: 429,
        message: 'A card was recently reordered. Please wait before requesting another reorder',
    },
    PAYCENTER_CARD_ACTIVATION_FAILED: {
        code: 'PAYCENTER_CARD_ACTIVATION_FAILED',
        status: 500,
        message: 'Failed to activate reordered card',
    },
    PAYCENTER_DEACTIVATION_FAILED: {
        code: 'PAYCENTER_DEACTIVATION_FAILED',
        status: 500,
        message: 'Failed to deactivate PayCenter account',
    },
    PAYCENTER_ALREADY_DEACTIVATED: {
        code: 'PAYCENTER_ALREADY_DEACTIVATED',
        status: 409,
        message: 'PayCenter account is already deactivated',
    },
    PAYCENTER_INVALID_IBAN_BIC: {
        code: 'PAYCENTER_INVALID_IBAN_BIC',
        status: 400,
        message: 'Invalid IBAN or BIC provided',
    },
    PAYCENTER_REGISTRATION_PENDING: {
        code: 'PAYCENTER_REGISTRATION_PENDING',
        status: 409,
        message: 'PayCenter registration already in progress',
    },
    PAYCENTER_ALREADY_REGISTERED: {
        code: 'PAYCENTER_ALREADY_REGISTERED',
        status: 409,
        message: 'PayCenter account already exists',
    },
    PAYCENTER_EMAIL_ALREADY_REGISTERED: {
        code: 'PAYCENTER_EMAIL_ALREADY_REGISTERED',
        status: 409,
        message: 'Email address is already registered with PayCenter',
    },
    PAYCENTER_PHONE_ALREADY_REGISTERED: {
        code: 'PAYCENTER_PHONE_ALREADY_REGISTERED',
        status: 409,
        message: 'Phone number is already registered with PayCenter',
    },
    PAYCENTER_KYC_REQUIRED: {
        code: 'PAYCENTER_KYC_REQUIRED',
        status: 422,
        message: 'Successful KYC verification required before opening PayCenter account',
    },
    STANDING_ORDER_INVALID_INTERVAL: {
        code: 'STANDING_ORDER_INVALID_INTERVAL',
        status: 400,
        message: 'Invalid standing order interval',
    },
    STANDING_ORDER_CREATION_FAILED: {
        code: 'STANDING_ORDER_CREATION_FAILED',
        status: 500,
        message: 'Failed to create standing order',
    },
    STANDING_ORDER_INVALID_START_DATE: {
        code: 'STANDING_ORDER_INVALID_START_DATE',
        status: 400,
        message: 'Invalid standing order start date',
    },
    STANDING_ORDER_NOT_FOUND: {
        code: 'STANDING_ORDER_NOT_FOUND',
        status: 404,
        message: 'Standing order not found',
    },
    STANDING_ORDER_CANNOT_CANCEL: {
        code: 'STANDING_ORDER_CANNOT_CANCEL',
        status: 400,
        message: 'Standing order cannot be cancelled in current state',
    },
    STANDING_ORDER_CANCELLATION_FAILED: {
        code: 'STANDING_ORDER_CANCELLATION_FAILED',
        status: 500,
        message: 'Failed to cancel standing order',
    },
    BENEFICIARY_NOT_FOUND: {
        code: 'BENEFICIARY_NOT_FOUND',
        status: 404,
        message: 'Beneficiary not found',
    },
    POSTIDENT_CONFIG_INVALID: {
        code: 'POSTIDENT_CONFIG_INVALID',
        status: 500,
        message: 'PostIdent configuration is invalid',
    },
    POSTIDENT_API_ERROR: { code: 'POSTIDENT_API_ERROR', status: 502, message: 'PostIdent service unavailable' },
    POSTIDENT_AUTHENTICATION_FAILED: {
        code: 'POSTIDENT_AUTHENTICATION_FAILED',
        status: 401,
        message: 'PostIdent authentication failed',
    },
    POSTIDENT_CASE_NOT_FOUND: {
        code: 'POSTIDENT_CASE_NOT_FOUND',
        status: 404,
        message: 'PostIdent case not found',
    },
    POSTIDENT_TIMEOUT: { code: 'POSTIDENT_TIMEOUT', status: 504, message: 'PostIdent request timeout' },
    POSTIDENT_ENCRYPTION_FAILED: {
        code: 'POSTIDENT_ENCRYPTION_FAILED',
        status: 500,
        message: 'PostIdent encryption failed',
    },
    POSTIDENT_DECRYPTION_FAILED: {
        code: 'POSTIDENT_DECRYPTION_FAILED',
        status: 500,
        message: 'PostIdent decryption failed',
    },
    POSTIDENT_INVALID_RESPONSE: {
        code: 'POSTIDENT_INVALID_RESPONSE',
        status: 502,
        message: 'PostIdent returned invalid response',
    },
    POSTIDENT_RATE_LIMIT: { code: 'POSTIDENT_RATE_LIMIT', status: 429, message: 'PostIdent rate limit exceeded' },
    TANGANY_AUTH_FAILED: { code: 'TANGANY_AUTH_FAILED', status: 401, message: 'Tangany authentication failed' },
    TANGANY_INSUFFICIENT_FUNDS: {
        code: 'TANGANY_INSUFFICIENT_FUNDS',
        status: 400,
        message: 'Insufficient funds for transaction',
    },
    TANGANY_INSUFFICIENT_GAS_FUNDS: {
        code: 'TANGANY_INSUFFICIENT_GAS_FUNDS',
        status: 400,
        message: 'Insufficient funds for network fees',
    },
    TANGANY_INVALID_ADDRESS: { code: 'TANGANY_INVALID_ADDRESS', status: 400, message: 'Invalid cryptocurrency address' },
    TANGANY_NETWORK_ERROR: {
        code: 'TANGANY_NETWORK_ERROR',
        status: 503,
        message: 'Tangany service temporarily unavailable',
    },
    TANGANY_WALLET_NOT_FOUND: { code: 'TANGANY_WALLET_NOT_FOUND', status: 404, message: 'Crypto wallet not found' },
    TANGANY_OPERATION_PENDING: {
        code: 'TANGANY_OPERATION_PENDING',
        status: 202,
        message: 'Operation is being processed',
    },
    TANGANY_OPERATION_FAILED: { code: 'TANGANY_OPERATION_FAILED', status: 400, message: 'Crypto operation failed' },
    TANGANY_OPERATION_TIMEOUT: { code: 'TANGANY_OPERATION_TIMEOUT', status: 408, message: 'Operation timed out' },
    TANGANY_ASSET_NOT_SUPPORTED: {
        code: 'TANGANY_ASSET_NOT_SUPPORTED',
        status: 400,
        message: 'Cryptocurrency asset not supported',
    },
    TANGANY_CUSTOMER_NOT_FOUND: {
        code: 'TANGANY_CUSTOMER_NOT_FOUND',
        status: 404,
        message: 'Tangany customer not found',
    },
    TANGANY_INVALID_AMOUNT: { code: 'TANGANY_INVALID_AMOUNT', status: 400, message: 'Invalid transaction amount' },
    TANGANY_FEE_ESTIMATION_FAILED: {
        code: 'TANGANY_FEE_ESTIMATION_FAILED',
        status: 400,
        message: 'Transaction fee estimation failed',
    },
    BLOCKCHAIN_SERVICE_UNAVAILABLE: {
        code: 'BLOCKCHAIN_SERVICE_UNAVAILABLE',
        status: 503,
        message: 'Blockchain data service temporarily unavailable',
    },
    BLOCKCHAIN_NETWORK_ERROR: {
        code: 'BLOCKCHAIN_NETWORK_ERROR',
        status: 503,
        message: 'Unable to connect to blockchain network',
    },
    BLOCKCHAIN_INVALID_BLOCK: {
        code: 'BLOCKCHAIN_INVALID_BLOCK',
        status: 400,
        message: 'Invalid block number or hash',
    },
    BLOCKCHAIN_ADDRESS_NOT_FOUND: {
        code: 'BLOCKCHAIN_ADDRESS_NOT_FOUND',
        status: 404,
        message: 'Blockchain address not found or has no activity',
    },
    CRYPTO_HISTORY_UNAVAILABLE: {
        code: 'CRYPTO_HISTORY_UNAVAILABLE',
        status: 503,
        message: 'Transaction history temporarily unavailable',
    },
    CRYPTO_UNSUPPORTED_NETWORK: {
        code: 'CRYPTO_UNSUPPORTED_NETWORK',
        status: 400,
        message: 'Blockchain network not supported',
    },
    CRYPTO_INVALID_CONTRACT: {
        code: 'CRYPTO_INVALID_CONTRACT',
        status: 400,
        message: 'Invalid token contract address',
    },
    CRYPTO_BALANCE_FETCH_FAILED: {
        code: 'CRYPTO_BALANCE_FETCH_FAILED',
        status: 503,
        message: 'Unable to fetch crypto balance',
    },
    ALCHEMY_API_ERROR: {
        code: 'ALCHEMY_API_ERROR',
        status: 502,
        message: 'Alchemy service error',
    },
    ALCHEMY_RATE_LIMIT: {
        code: 'ALCHEMY_RATE_LIMIT',
        status: 429,
        message: 'Alchemy API rate limit exceeded',
    },
    MEMPOOL_API_ERROR: {
        code: 'MEMPOOL_API_ERROR',
        status: 502,
        message: 'Bitcoin network data unavailable',
    },
    MEMPOOL_INVALID_ADDRESS: {
        code: 'MEMPOOL_INVALID_ADDRESS',
        status: 400,
        message: 'Invalid Bitcoin address format',
    },
    MEMPOOL_RATE_LIMIT: {
        code: 'MEMPOOL_RATE_LIMIT',
        status: 429,
        message: 'Mempool API rate limit exceeded',
    },
    BTCDIRECT_AUTH_FAILED: { code: 'BTCDIRECT_AUTH_FAILED', status: 401, message: 'BTCDirect authentication failed' },
    BTCDIRECT_API_ERROR: { code: 'BTCDIRECT_API_ERROR', status: 502, message: 'BTCDirect service unavailable' },
    BTCDIRECT_RATE_LIMIT: { code: 'BTCDIRECT_RATE_LIMIT', status: 429, message: 'BTCDirect rate limit exceeded' },
    BTCDIRECT_QUOTE_EXPIRED: { code: 'BTCDIRECT_QUOTE_EXPIRED', status: 400, message: 'Sell quote has expired' },
    BTCDIRECT_QUOTE_NOT_FOUND: { code: 'BTCDIRECT_QUOTE_NOT_FOUND', status: 404, message: 'Sell quote not found' },
    BTCDIRECT_ORDER_NOT_FOUND: { code: 'BTCDIRECT_ORDER_NOT_FOUND', status: 404, message: 'Sell order not found' },
    BTCDIRECT_INVALID_AMOUNT: { code: 'BTCDIRECT_INVALID_AMOUNT', status: 400, message: 'Invalid sell amount' },
    BTCDIRECT_INVALID_IBAN: { code: 'BTCDIRECT_INVALID_IBAN', status: 400, message: 'Invalid IBAN format' },
    BTCDIRECT_INVALID_DATA: {
        code: 'BTCDIRECT_INVALID_DATA',
        status: 400,
        message: 'Invalid data provided to BTCDirect',
    },
    BTCDIRECT_UNKNOWN_IBAN: {
        code: 'BTCDIRECT_UNKNOWN_IBAN',
        status: 400,
        message: 'IBAN not registered with user account',
    },
    BTCDIRECT_UNSUPPORTED_CURRENCY: {
        code: 'BTCDIRECT_UNSUPPORTED_CURRENCY',
        status: 400,
        message: 'Currency pair not supported',
    },
    BTCDIRECT_CUSTOMER_NOT_FOUND: {
        code: 'BTCDIRECT_CUSTOMER_NOT_FOUND',
        status: 404,
        message: 'BTCDirect customer not found',
    },
    BTCDIRECT_ADDRESS_NOT_WHITELISTED: {
        code: 'BTCDIRECT_ADDRESS_NOT_WHITELISTED',
        status: 403,
        message: 'Destination address not whitelisted',
    },
    BTCDIRECT_ORDER_FAILED: { code: 'BTCDIRECT_ORDER_FAILED', status: 400, message: 'Sell order processing failed' },
    BTCDIRECT_WEBHOOK_INVALID: { code: 'BTCDIRECT_WEBHOOK_INVALID', status: 400, message: 'Invalid webhook signature' },
    TRADEVEST_AUTH_FAILED: { code: 'TRADEVEST_AUTH_FAILED', status: 401, message: 'Tradevest authentication failed' },
    TRADEVEST_API_ERROR: { code: 'TRADEVEST_API_ERROR', status: 502, message: 'Tradevest service unavailable' },
    TRADEVEST_RATE_LIMIT: { code: 'TRADEVEST_RATE_LIMIT', status: 429, message: 'Tradevest rate limit exceeded' },
    TRADEVEST_INVALID_TOKEN: { code: 'TRADEVEST_INVALID_TOKEN', status: 401, message: 'Invalid Tradevest access token' },
    TRADEVEST_TOKEN_REFRESH_FAILED: {
        code: 'TRADEVEST_TOKEN_REFRESH_FAILED',
        status: 500,
        message: 'Failed to refresh Tradevest token',
    },
    TRADEVEST_INVALID_REQUEST: {
        code: 'TRADEVEST_INVALID_REQUEST',
        status: 400,
        message: 'Invalid request to Tradevest API',
    },
    TRADEVEST_ALREADY_REGISTERED: {
        code: 'TRADEVEST_ALREADY_REGISTERED',
        status: 409,
        message: 'Tradevest account already registered',
    },
    TRADEVEST_FSA_ALREADY_EXISTS: {
        code: 'TRADEVEST_FSA_ALREADY_EXISTS',
        status: 409,
        message: 'A Freistellungsauftrag is already on file',
    },
    TRADEVEST_KYC_REQUIRED: {
        code: 'TRADEVEST_KYC_REQUIRED',
        status: 422,
        message: 'Successful KYC verification required before Tradevest onboarding',
    },
    TRADEVEST_ONBOARDING_IN_PROGRESS: {
        code: 'TRADEVEST_ONBOARDING_IN_PROGRESS',
        status: 409,
        message: 'Tradevest onboarding already in progress',
    },
    TRADEVEST_ACCOUNT_NOT_FOUND: {
        code: 'TRADEVEST_ACCOUNT_NOT_FOUND',
        status: 404,
        message: 'Tradevest account not found',
    },
    TRADEVEST_NOT_ONBOARDED: {
        code: 'TRADEVEST_NOT_ONBOARDED',
        status: 422,
        message: 'User must complete Tradevest onboarding first',
    },
    TRADEVEST_TAX_ID_REQUIRED: {
        code: 'TRADEVEST_TAX_ID_REQUIRED',
        status: 422,
        message: 'A tax identification number is required for your tax residency',
    },
    TRADEVEST_TAX_ID_INVALID: {
        code: 'TRADEVEST_TAX_ID_INVALID',
        status: 400,
        message: 'The tax identification number is not valid',
    },
    TRADEVEST_INSUFFICIENT_BALANCE: {
        code: 'TRADEVEST_INSUFFICIENT_BALANCE',
        status: 422,
        message: 'Insufficient balance for trade',
    },
    TRADEVEST_ASSET_NOT_AVAILABLE: {
        code: 'TRADEVEST_ASSET_NOT_AVAILABLE',
        status: 400,
        message: 'Asset is not available for trading',
    },
    TRADEVEST_ORDER_NOT_FOUND: {
        code: 'TRADEVEST_ORDER_NOT_FOUND',
        status: 404,
        message: 'Order not found',
    },
    TRADEVEST_ORDER_REJECTED: {
        code: 'TRADEVEST_ORDER_REJECTED',
        status: 422,
        message: 'Order was rejected by Tradevest',
    },
    TRADEVEST_MARKET_CLOSED: {
        code: 'TRADEVEST_MARKET_CLOSED',
        status: 503,
        message: 'The trading venue is currently closed',
    },
    TRADEVEST_INVALID_QUANTITY: {
        code: 'TRADEVEST_INVALID_QUANTITY',
        status: 400,
        message: 'Invalid quantity for trade',
    },
    TRADEVEST_INVALID_AMOUNT: {
        code: 'TRADEVEST_INVALID_AMOUNT',
        status: 400,
        message: 'Invalid amount for transfer',
    },
    TRADEVEST_INVALID_IBAN: {
        code: 'TRADEVEST_INVALID_IBAN',
        status: 400,
        message: 'Invalid IBAN format',
    },
    TRADEVEST_RECEIVER_NOT_REF_ACCOUNT: {
        code: 'TRADEVEST_RECEIVER_NOT_REF_ACCOUNT',
        status: 400,
        message: 'Receiver IBAN is not a registered reference account',
    },
    TRADEVEST_REF_ACCOUNT_OWNER_MISMATCH: {
        code: 'TRADEVEST_REF_ACCOUNT_OWNER_MISMATCH',
        status: 400,
        message: 'Account holder does not match the customer',
    },
    TRADEVEST_ONE_TAP_REGISTRATION_DISABLED: {
        code: 'TRADEVEST_ONE_TAP_REGISTRATION_DISABLED',
        status: 409,
        message: 'Reference-account registration during a transfer is not enabled',
    },
    TRADEVEST_DEPOSIT_METHOD_UNAVAILABLE: {
        code: 'TRADEVEST_DEPOSIT_METHOD_UNAVAILABLE',
        status: 422,
        message: 'This deposit method is not available for your account',
    },
    TRADEVEST_DEPOSIT_SOURCE_NOT_REF_ACCOUNT: {
        code: 'TRADEVEST_DEPOSIT_SOURCE_NOT_REF_ACCOUNT',
        status: 409,
        message: 'The source account is not registered as a reference account',
    },
    TRADEVEST_DEPOSIT_NOT_FOUND: {
        code: 'TRADEVEST_DEPOSIT_NOT_FOUND',
        status: 404,
        message: 'Deposit not found',
    },
    TRADEVEST_TRANSFER_NOT_FOUND: {
        code: 'TRADEVEST_TRANSFER_NOT_FOUND',
        status: 404,
        message: 'Transfer not found',
    },
    TRADEVEST_DOCUMENTS_NOT_FOUND: {
        code: 'TRADEVEST_DOCUMENTS_NOT_FOUND',
        status: 404,
        message: 'Required Tradevest partner documents not found',
    },
    TRADEVEST_RECEIPT_NOT_READY: {
        code: 'TRADEVEST_RECEIPT_NOT_READY',
        status: 404,
        message: 'Receipt is still being generated',
    },
    TRADEVEST_RECEIPT_EXPIRED: {
        code: 'TRADEVEST_RECEIPT_EXPIRED',
        status: 410,
        message: 'Receipt is no longer available upstream',
    },
    TRADEVEST_SERVICE_UNAVAILABLE: {
        code: 'TRADEVEST_SERVICE_UNAVAILABLE',
        status: 503,
        message: 'Tradevest service is not configured',
    },
    TRADEVEST_QUALIFICATION_REQUIRED: {
        code: 'TRADEVEST_QUALIFICATION_REQUIRED',
        status: 422,
        message: 'Investor qualification required for this asset type before trading',
    },
    TRADEVEST_RISK_ACKNOWLEDGEMENT_REQUIRED: {
        code: 'TRADEVEST_RISK_ACKNOWLEDGEMENT_REQUIRED',
        status: 422,
        message: 'Risk warning must be acknowledged before trading this asset type',
    },
    TRADEVEST_EX_ANTE_REQUIRED: {
        code: 'TRADEVEST_EX_ANTE_REQUIRED',
        status: 400,
        message: 'An ex-ante cost disclosure is required before placing an order',
    },
    TRADEVEST_EX_ANTE_NOT_SHOWN: {
        code: 'TRADEVEST_EX_ANTE_NOT_SHOWN',
        status: 422,
        message: 'The ex-ante cost disclosure was not delivered before the order',
    },
    TRADEVEST_EX_ANTE_ALREADY_USED: {
        code: 'TRADEVEST_EX_ANTE_ALREADY_USED',
        status: 409,
        message: 'The ex-ante cost disclosure is already linked to an order',
    },
    TRADEVEST_EX_ANTE_MISMATCH: {
        code: 'TRADEVEST_EX_ANTE_MISMATCH',
        status: 422,
        message: 'Order does not match the disclosed ex-ante calculation',
    },
    TRANSACTION_NOT_FOUND: {
        code: 'TRANSACTION_NOT_FOUND',
        status: 404,
        message: 'Transaction not found',
    },
    TRANSACTION_ALREADY_PROCESSED: {
        code: 'TRANSACTION_ALREADY_PROCESSED',
        status: 409,
        message: 'Transaction already processed',
    },
    TRANSACTION_PROCESSING_FAILED: {
        code: 'TRANSACTION_PROCESSING_FAILED',
        status: 500,
        message: 'Transaction processing failed',
    },
    TRANSACTION_QUEUE_FULL: {
        code: 'TRANSACTION_QUEUE_FULL',
        status: 503,
        message: 'Transaction queue is full, please try again later',
    },
    TRANSACTION_TIMEOUT: {
        code: 'TRANSACTION_TIMEOUT',
        status: 408,
        message: 'Transaction processing timed out',
    },
    IBAN_INVALID_FORMAT: { code: 'IBAN_INVALID_FORMAT', status: 400, message: 'Invalid IBAN format' },
    IBAN_INVALID_CHECKSUM: { code: 'IBAN_INVALID_CHECKSUM', status: 400, message: 'Invalid IBAN checksum' },
    IBAN_COUNTRY_NOT_SUPPORTED: {
        code: 'IBAN_COUNTRY_NOT_SUPPORTED',
        status: 400,
        message: 'Country does not support IBAN',
    },
    IBAN_INVALID_ACCOUNT_NUMBER: {
        code: 'IBAN_INVALID_ACCOUNT_NUMBER',
        status: 400,
        message: 'The account number in this IBAN fails its check digit',
    },
    IBAN_SEPA_NOT_SUPPORTED: {
        code: 'IBAN_SEPA_NOT_SUPPORTED',
        status: 400,
        message: 'This bank does not accept SEPA credit transfers',
    },
    IBAN_VALIDATION_FAILED: { code: 'IBAN_VALIDATION_FAILED', status: 400, message: 'IBAN validation failed' },
    IBAN_QUOTA_EXCEEDED: { code: 'IBAN_QUOTA_EXCEEDED', status: 429, message: 'Monthly IBAN validation quota exceeded' },
    IBAN_SERVICE_UNAVAILABLE: {
        code: 'IBAN_SERVICE_UNAVAILABLE',
        status: 503,
        message: 'IBAN validation service unavailable',
    },
    TRANSACTION_QUEUE_NOT_FOUND: {
        code: 'TRANSACTION_QUEUE_NOT_FOUND',
        status: 404,
        message: 'Transaction not found in queue',
    },
    TRANSACTION_ALREADY_APPROVED: {
        code: 'TRANSACTION_ALREADY_APPROVED',
        status: 409,
        message: 'Transaction has already been approved',
    },
    TRANSACTION_ALREADY_PROCESSING: {
        code: 'TRANSACTION_ALREADY_PROCESSING',
        status: 409,
        message: 'Transaction is already being processed',
    },
    TRANSACTION_CANNOT_APPROVE: {
        code: 'TRANSACTION_CANNOT_APPROVE',
        status: 400,
        message: 'Transaction cannot be approved in current state',
    },
    TRANSACTION_CANNOT_REJECT: {
        code: 'TRANSACTION_CANNOT_REJECT',
        status: 400,
        message: 'Transaction cannot be rejected in current state',
    },
    TRANSACTION_CANNOT_CANCEL: {
        code: 'TRANSACTION_CANNOT_CANCEL',
        status: 400,
        message: 'Transaction cannot be canceled in current state',
    },
    TRANSACTION_CANNOT_RETRY: {
        code: 'TRANSACTION_CANNOT_RETRY',
        status: 400,
        message: 'Transaction cannot be retried in current state',
    },
    TRANSACTION_MAX_RETRIES_EXCEEDED: {
        code: 'TRANSACTION_MAX_RETRIES_EXCEEDED',
        status: 422,
        message: 'Maximum retry limit reached for this transaction',
    },
    DUPLICATE_TRANSACTION_DETECTED: {
        code: 'DUPLICATE_TRANSACTION_DETECTED',
        status: 409,
        message: 'Duplicate transaction detected for this standing order and date',
    },
    INSUFFICIENT_PERMISSIONS: {
        code: 'INSUFFICIENT_PERMISSIONS',
        status: 403,
        message: 'Insufficient permissions for this operation',
    },
    STANDING_ORDER_PAUSED: {
        code: 'STANDING_ORDER_PAUSED',
        status: 400,
        message: 'Standing order is paused and cannot generate transactions',
    },
    TRANSACTION_GENERATION_FAILED: {
        code: 'TRANSACTION_GENERATION_FAILED',
        status: 500,
        message: 'Failed to generate transaction from standing order',
    },
    BULK_OPERATION_PARTIAL_FAILURE: {
        code: 'BULK_OPERATION_PARTIAL_FAILURE',
        status: 207,
        message: 'Some operations in bulk request failed',
    },
    PUSH_TOKEN_INVALID: {
        code: 'PUSH_TOKEN_INVALID',
        status: 400,
        message: 'Invalid push notification token format',
    },
    PUSH_TOKEN_NOT_FOUND: {
        code: 'PUSH_TOKEN_NOT_FOUND',
        status: 404,
        message: 'Push notification token not found',
    },
    PUSH_TOKEN_ALREADY_REGISTERED: {
        code: 'PUSH_TOKEN_ALREADY_REGISTERED',
        status: 409,
        message: 'Push token already registered',
    },
    NOTIFICATION_FAILED: {
        code: 'NOTIFICATION_FAILED',
        status: 500,
        message: 'Failed to send notification',
    },
    DEVICE_NOT_REGISTERED: {
        code: 'DEVICE_NOT_REGISTERED',
        status: 404,
        message: 'Device not registered for push notifications',
    },
    NOTIFICATION_SERVICE_UNAVAILABLE: {
        code: 'NOTIFICATION_SERVICE_UNAVAILABLE',
        status: 503,
        message: 'Notification service temporarily unavailable',
    },
    BROADCAST_NOT_FOUND: {
        code: 'BROADCAST_NOT_FOUND',
        status: 404,
        message: 'Broadcast not found',
    },
    TRANSLATION_FAILED: {
        code: 'TRANSLATION_FAILED',
        status: 502,
        message: 'Translation service failed',
    },
    NOTIFICATION_RATE_LIMIT_EXCEEDED: {
        code: 'NOTIFICATION_RATE_LIMIT_EXCEEDED',
        status: 429,
        message: 'Too many notifications sent',
    },
    NOTIFICATION_PAYLOAD_TOO_LARGE: {
        code: 'NOTIFICATION_PAYLOAD_TOO_LARGE',
        status: 400,
        message: 'Notification payload exceeds size limit',
    },
    PDF_GENERATION_FAILED: {
        code: 'PDF_GENERATION_FAILED',
        status: 500,
        message: 'Failed to generate PDF document',
    },
    PDF_TEMPLATE_NOT_FOUND: {
        code: 'PDF_TEMPLATE_NOT_FOUND',
        status: 404,
        message: 'PDF template not found',
    },
    PDF_TEMPLATE_RENDER_ERROR: {
        code: 'PDF_TEMPLATE_RENDER_ERROR',
        status: 500,
        message: 'Failed to render PDF template',
    },
    PDF_INVALID_DATA: {
        code: 'PDF_INVALID_DATA',
        status: 400,
        message: 'Invalid data provided for PDF generation',
    },
    PDF_STREAM_ERROR: {
        code: 'PDF_STREAM_ERROR',
        status: 500,
        message: 'Error streaming PDF document',
    },
    PDF_EMAIL_SEND_FAILED: {
        code: 'PDF_EMAIL_SEND_FAILED',
        status: 500,
        message: 'Failed to send PDF via email',
    },
    PDF_SERVICE_UNAVAILABLE: {
        code: 'PDF_SERVICE_UNAVAILABLE',
        status: 503,
        message: 'PDF generation service temporarily unavailable',
    },
    DOCUMENT_PASSWORD_NOT_FOUND: {
        code: 'DOCUMENT_PASSWORD_NOT_FOUND',
        status: 404,
        message: 'Document password not found',
    },
    DOCUMENT_PASSWORD_ALREADY_EXISTS: {
        code: 'DOCUMENT_PASSWORD_ALREADY_EXISTS',
        status: 409,
        message: 'Document password already exists',
    },
    DOCUMENT_PASSWORD_ENCRYPTION_FAILED: {
        code: 'DOCUMENT_PASSWORD_ENCRYPTION_FAILED',
        status: 500,
        message: 'Failed to encrypt document password',
    },
    DOCUMENT_PASSWORD_DECRYPTION_FAILED: {
        code: 'DOCUMENT_PASSWORD_DECRYPTION_FAILED',
        status: 500,
        message: 'Failed to decrypt document password',
    },
    SUBSCRIPTION_NOT_FOUND: {
        code: 'SUBSCRIPTION_NOT_FOUND',
        status: 404,
        message: 'Subscription not found',
    },
    USER_COUNTRY_NOT_SET: {
        code: 'USER_COUNTRY_NOT_SET',
        status: 422,
        message: 'User country must be set before billing. Please complete address verification.',
    },
    INVALID_COUNTRY_CODE: {
        code: 'INVALID_COUNTRY_CODE',
        status: 400,
        message: 'Invalid ISO country code',
    },
    VAT_CALCULATION_FAILED: {
        code: 'VAT_CALCULATION_FAILED',
        status: 500,
        message: 'Failed to calculate VAT for subscription',
    },
    VAT_RATE_NOT_FOUND: {
        code: 'VAT_RATE_NOT_FOUND',
        status: 400,
        message: 'VAT rate not found for country',
    },
    SUBSCRIPTION_COUNTRY_REQUIRED: {
        code: 'SUBSCRIPTION_COUNTRY_REQUIRED',
        status: 422,
        message: 'Country is required for SMART plan subscription',
    },
    CSV_IMPORT_EMPTY: {
        code: 'CSV_IMPORT_EMPTY',
        status: 400,
        message: 'No users to import',
    },
    CSV_IMPORT_TOO_MANY_ROWS: {
        code: 'CSV_IMPORT_TOO_MANY_ROWS',
        status: 400,
        message: 'CSV exceeds maximum row limit (1000)',
    },
    CSV_IMPORT_INVALID_DATA: {
        code: 'CSV_IMPORT_INVALID_DATA',
        status: 400,
        message: 'Invalid data in import request',
    },
    REFERRAL_NOT_FOUND: {
        code: 'REFERRAL_NOT_FOUND',
        status: 404,
        message: 'Referral not found',
    },
    REFERRAL_CODE_INVALID: {
        code: 'REFERRAL_CODE_INVALID',
        status: 400,
        message: 'Invalid referral code',
    },
    REFERRAL_ALREADY_EXISTS: {
        code: 'REFERRAL_ALREADY_EXISTS',
        status: 409,
        message: 'User already has a referral',
    },
    REFERRAL_SELF_REFERRAL: {
        code: 'REFERRAL_SELF_REFERRAL',
        status: 400,
        message: 'Cannot use own referral code',
    },
    REFERRAL_ATTRIBUTION_EXPIRED: {
        code: 'REFERRAL_ATTRIBUTION_EXPIRED',
        status: 400,
        message: 'Referral attribution window has expired',
    },
    REFERRAL_PROGRAM_PAUSED: {
        code: 'REFERRAL_PROGRAM_PAUSED',
        status: 400,
        message: 'Referral program is currently paused',
    },
    REFERRAL_MAX_REACHED: {
        code: 'REFERRAL_MAX_REACHED',
        status: 400,
        message: 'Maximum referrals per user reached',
    },
    REFERRAL_ALREADY_REJECTED: {
        code: 'REFERRAL_ALREADY_REJECTED',
        status: 409,
        message: 'Referral has already been rejected',
    },
    REFERRAL_CANNOT_REJECT: {
        code: 'REFERRAL_CANNOT_REJECT',
        status: 400,
        message: 'Referral cannot be rejected in current state',
    },
    REFERRAL_CANNOT_FORCE_QUALIFY: {
        code: 'REFERRAL_CANNOT_FORCE_QUALIFY',
        status: 400,
        message: 'Referral cannot be force-qualified in current state',
    },
    REFERRAL_REWARD_NOT_FAILED: {
        code: 'REFERRAL_REWARD_NOT_FAILED',
        status: 400,
        message: 'Only failed rewards can be retried',
    },
    REFERRAL_REWARD_DISTRIBUTION_FAILED: {
        code: 'REFERRAL_REWARD_DISTRIBUTION_FAILED',
        status: 500,
        message: 'Failed to distribute referral reward',
    },
    REFERRAL_APPLY_WINDOW_EXPIRED: {
        code: 'REFERRAL_APPLY_WINDOW_EXPIRED',
        status: 400,
        message: 'Referral code can only be applied within 24 hours of account creation',
    },
    ASSET_NOT_FOUND: {
        code: 'ASSET_NOT_FOUND',
        status: 404,
        message: 'Asset not found',
    },
    ASSET_ALREADY_EXISTS: {
        code: 'ASSET_ALREADY_EXISTS',
        status: 409,
        message: 'Asset with this symbol already exists in this category',
    },
    ISSUER_NOT_FOUND: { code: 'ISSUER_NOT_FOUND', status: 404, message: 'Issuer not found' },
    ISSUER_ASSET_NOT_FOUND: { code: 'ISSUER_ASSET_NOT_FOUND', status: 404, message: 'Issuer asset not found' },
    ISSUER_ASSET_ALREADY_LINKED: {
        code: 'ISSUER_ASSET_ALREADY_LINKED',
        status: 409,
        message: 'This issuer asset is already linked to another asset',
    },
    ISSUER_LINK_CATEGORY_MISMATCH: {
        code: 'ISSUER_LINK_CATEGORY_MISMATCH',
        status: 400,
        message: 'Only RWA assets can be linked to an issuer asset',
    },
    ISSUER_API_ERROR: { code: 'ISSUER_API_ERROR', status: 502, message: 'Issuer API request failed' },
    RWA_CONTENT_NOT_FOUND: { code: 'RWA_CONTENT_NOT_FOUND', status: 404, message: 'RWA content not available' },
    BRAND_SPACE_NOT_FOUND: { code: 'BRAND_SPACE_NOT_FOUND', status: 404, message: 'Brand space not found' },
    BRAND_SPACE_NOT_READY: {
        code: 'BRAND_SPACE_NOT_READY',
        status: 422,
        message: 'The brand space cannot be enabled until its checklist passes',
    },
    RWA_CONSENT_REQUIRED: {
        code: 'RWA_CONSENT_REQUIRED',
        status: 422,
        message: 'The issuer documents must be acknowledged before investing in this asset',
    },
    TRADEVEST_ORDER_SIZE_BELOW_MINIMUM: {
        code: 'TRADEVEST_ORDER_SIZE_BELOW_MINIMUM',
        status: 422,
        message: 'The order is smaller than the venue allows for this asset',
    },
    TRADEVEST_ORDER_SIZE_ABOVE_MAXIMUM: {
        code: 'TRADEVEST_ORDER_SIZE_ABOVE_MAXIMUM',
        status: 422,
        message: 'The order is larger than the venue allows for this asset',
    },
    TRADEVEST_ORDER_AMOUNT_UNSUPPORTED: {
        code: 'TRADEVEST_ORDER_AMOUNT_UNSUPPORTED',
        status: 422,
        message: 'This asset cannot be ordered by euro amount',
    },
    TRADEVEST_APPROPRIATENESS_REQUIRED: {
        code: 'TRADEVEST_APPROPRIATENESS_REQUIRED',
        status: 422,
        message: 'The appropriateness test for this asset type must be passed before investing',
    },
    TRADEVEST_APPROPRIATENESS_PENDING: {
        code: 'TRADEVEST_APPROPRIATENESS_PENDING',
        status: 422,
        message: 'The appropriateness test is still being scored',
    },
    RWA_ASSET_NOT_PURCHASABLE: {
        code: 'RWA_ASSET_NOT_PURCHASABLE',
        status: 422,
        message: 'This asset cannot be purchased right now',
    },
    RWA_SELL_NOT_ALLOWED: {
        code: 'RWA_SELL_NOT_ALLOWED',
        status: 422,
        message: 'This asset cannot be sold back right now',
    },
    RWA_COSTS_UNAVAILABLE: {
        code: 'RWA_COSTS_UNAVAILABLE',
        status: 422,
        message: 'No cost disclosure is published for this asset',
    },
    RWA_ORDER_NOT_CANCELLABLE: {
        code: 'RWA_ORDER_NOT_CANCELLABLE',
        status: 409,
        message: 'This order can no longer be withdrawn',
    },
    RWA_ASSET_ACTIVE: {
        code: 'RWA_ASSET_ACTIVE',
        status: 409,
        message: 'Deactivate the RWA asset before removing what keeps it activatable',
    },
    RWA_ACTIVATION_BLOCKED: {
        code: 'RWA_ACTIVATION_BLOCKED',
        status: 422,
        message: 'RWA asset cannot be activated until its checklist is complete',
    },
    ASSET_DISABLED: {
        code: 'ASSET_DISABLED',
        status: 400,
        message: 'Asset is currently disabled',
    },
    ASSET_CATEGORY_DISABLED: {
        code: 'ASSET_CATEGORY_DISABLED',
        status: 400,
        message: 'Asset category is currently disabled',
    },
    PROVIDER_ASSET_LINK_NOT_FOUND: {
        code: 'PROVIDER_ASSET_LINK_NOT_FOUND',
        status: 404,
        message: 'Provider-asset link not found',
    },
    PROVIDER_ASSET_LINK_ALREADY_EXISTS: {
        code: 'PROVIDER_ASSET_LINK_ALREADY_EXISTS',
        status: 409,
        message: 'Provider-asset link already exists',
    },
    TRADEVEST_IMPORT_FAILED: {
        code: 'TRADEVEST_IMPORT_FAILED',
        status: 500,
        message: 'Failed to import assets from Tradevest',
    },
    PROVIDER_NOT_AVAILABLE: {
        code: 'PROVIDER_NOT_AVAILABLE',
        status: 400,
        message: 'No provider available for this operation',
    },
    CARD_RENEWAL_DRAFT_NOT_FOUND: {
        code: 'CARD_RENEWAL_DRAFT_NOT_FOUND',
        status: 404,
        message: 'Card renewal draft not found',
    },
    CARD_RENEWAL_DRAFT_ALREADY_EXISTS: {
        code: 'CARD_RENEWAL_DRAFT_ALREADY_EXISTS',
        status: 409,
        message: 'A card renewal draft already exists for this user and expiration date',
    },
    CARD_RENEWAL_CANNOT_APPROVE: {
        code: 'CARD_RENEWAL_CANNOT_APPROVE',
        status: 400,
        message: 'Card renewal draft cannot be approved in current state',
    },
    CARD_RENEWAL_CANNOT_REJECT: {
        code: 'CARD_RENEWAL_CANNOT_REJECT',
        status: 400,
        message: 'Card renewal draft cannot be rejected in current state',
    },
    CARD_RENEWAL_ADDRESS_REQUIRED: {
        code: 'CARD_RENEWAL_ADDRESS_REQUIRED',
        status: 400,
        message: 'Delivery address is required for card renewal',
    },
    CARD_RENEWAL_INVALID_STATUS_TRANSITION: {
        code: 'CARD_RENEWAL_INVALID_STATUS_TRANSITION',
        status: 400,
        message: 'Invalid status transition for card renewal draft',
    },
    CARD_RENEWAL_USER_ALREADY_ORDERED: {
        code: 'CARD_RENEWAL_USER_ALREADY_ORDERED',
        status: 409,
        message: 'User has already ordered a replacement card',
    },
    CARD_RENEWAL_IN_PROGRESS: {
        code: 'CARD_RENEWAL_IN_PROGRESS',
        status: 409,
        message: 'Cannot delete account while card renewal is in progress. Please wait for the card order to complete.',
    },
    CARD_ORDER_NOT_FOUND: {
        code: 'CARD_ORDER_NOT_FOUND',
        status: 404,
        message: 'Card order not found',
    },
    THREE_DS_CHALLENGE_NOT_FOUND: {
        code: 'THREE_DS_CHALLENGE_NOT_FOUND',
        status: 404,
        message: '3DS challenge not found',
    },
    THREE_DS_CHALLENGE_ALREADY_RESPONDED: {
        code: 'THREE_DS_CHALLENGE_ALREADY_RESPONDED',
        status: 409,
        message: '3DS challenge has already been responded to',
    },
    THREE_DS_CHALLENGE_EXPIRED: {
        code: 'THREE_DS_CHALLENGE_EXPIRED',
        status: 410,
        message: '3DS challenge has expired',
    },
    THREE_DS_USER_NOT_FOUND: {
        code: 'THREE_DS_USER_NOT_FOUND',
        status: 404,
        message: 'No user found for this 3DS challenge',
    },
    THREE_DS_CONFIRMATION_FAILED: {
        code: 'THREE_DS_CONFIRMATION_FAILED',
        status: 502,
        message: 'Could not confirm the payment with the provider. Please try again.',
    },
    LEGAL_DOCUMENT_NOT_FOUND: {
        code: 'LEGAL_DOCUMENT_NOT_FOUND',
        status: 404,
        message: 'Legal document not found',
    },
    LEGAL_DOCUMENT_NOT_ACTIVE: {
        code: 'LEGAL_DOCUMENT_NOT_ACTIVE',
        status: 400,
        message: 'Document is not active',
    },
    LEGAL_DOCUMENT_ALREADY_ACCEPTED: {
        code: 'LEGAL_DOCUMENT_ALREADY_ACCEPTED',
        status: 409,
        message: 'Document already accepted',
    },
    LEGAL_DOCUMENT_CANNOT_EDIT: {
        code: 'LEGAL_DOCUMENT_CANNOT_EDIT',
        status: 400,
        message: 'Only draft documents can be edited',
    },
    LEGAL_DOCUMENT_CANNOT_PUBLISH: {
        code: 'LEGAL_DOCUMENT_CANNOT_PUBLISH',
        status: 400,
        message: 'Only draft documents can be published',
    },
    LEGAL_DOCUMENT_CANNOT_ARCHIVE: {
        code: 'LEGAL_DOCUMENT_CANNOT_ARCHIVE',
        status: 400,
        message: 'Only active documents can be archived',
    },
    LEGAL_DOCUMENT_SLUG_VERSION_EXISTS: {
        code: 'LEGAL_DOCUMENT_SLUG_VERSION_EXISTS',
        status: 409,
        message: 'Document with this slug and version already exists',
    },
    WITHDRAWAL_ALREADY_DECLARED: {
        code: 'WITHDRAWAL_ALREADY_DECLARED',
        status: 409,
        message: 'A withdrawal has already been declared for this contract',
    },
    WITHDRAWAL_CONTRACT_NOT_ELIGIBLE: {
        code: 'WITHDRAWAL_CONTRACT_NOT_ELIGIBLE',
        status: 422,
        message: 'This contract is not currently within its withdrawal period',
    },
    TRADEVEST_CANCELLATION_NOT_ELIGIBLE: {
        code: 'TRADEVEST_CANCELLATION_NOT_ELIGIBLE',
        status: 422,
        message: 'There is no active Tradevest contract to cancel',
    },
    TRADEVEST_ALREADY_CANCELLING: {
        code: 'TRADEVEST_ALREADY_CANCELLING',
        status: 409,
        message: 'A cancellation for the Tradevest contract is already in progress',
    },
    FINAPI_DISABLED: {
        code: 'FINAPI_DISABLED',
        status: 403,
        message: 'finAPI feature is not enabled',
    },
    FINAPI_AUTH_FAILED: {
        code: 'FINAPI_AUTH_FAILED',
        status: 502,
        message: 'finAPI authentication failed',
    },
    FINAPI_USER_NOT_FOUND: {
        code: 'FINAPI_USER_NOT_FOUND',
        status: 404,
        message: 'finAPI user not found',
    },
    FINAPI_RATE_LIMITED: {
        code: 'FINAPI_RATE_LIMITED',
        status: 429,
        message: 'finAPI rate limit exceeded',
    },
    FINAPI_TIMEOUT: {
        code: 'FINAPI_TIMEOUT',
        status: 504,
        message: 'finAPI request timed out',
    },
    FINAPI_UPSTREAM_ERROR: {
        code: 'FINAPI_UPSTREAM_ERROR',
        status: 502,
        message: 'finAPI service unavailable',
    },
    FINAPI_BAD_REQUEST: {
        code: 'FINAPI_BAD_REQUEST',
        status: 400,
        message: 'Invalid request to finAPI',
    },
    FINAPI_CONSENT_EXPIRED: {
        code: 'FINAPI_CONSENT_EXPIRED',
        status: 409,
        message: 'PSD2 consent has expired, please reauthorize the bank connection',
    },
    FINAPI_CONSENT_REVOKED: {
        code: 'FINAPI_CONSENT_REVOKED',
        status: 409,
        message: 'PSD2 consent was revoked',
    },
    FINAPI_CONNECTION_NOT_FOUND: {
        code: 'FINAPI_CONNECTION_NOT_FOUND',
        status: 404,
        message: 'Bank connection not found',
    },
    FINAPI_CONNECTION_UPDATE_REQUIRED: {
        code: 'FINAPI_CONNECTION_UPDATE_REQUIRED',
        status: 409,
        message: 'Bank connection requires re-authorization',
    },
    FINAPI_WEBFORM_EXPIRED: {
        code: 'FINAPI_WEBFORM_EXPIRED',
        status: 409,
        message: 'Web form session expired, please start a new one',
    },
    FINAPI_WEBFORM_NOT_FOUND: {
        code: 'FINAPI_WEBFORM_NOT_FOUND',
        status: 404,
        message: 'Web form session not found',
    },
    FINAPI_ACCOUNT_LINK_FAILED: {
        code: 'FINAPI_ACCOUNT_LINK_FAILED',
        status: 502,
        message: 'Failed to link bank account',
    },
    FINAPI_BANK_NOT_SUPPORTED: {
        code: 'FINAPI_BANK_NOT_SUPPORTED',
        status: 422,
        message: 'The selected bank does not support this operation',
    },
    FINAPI_BANK_UNAVAILABLE: {
        code: 'FINAPI_BANK_UNAVAILABLE',
        status: 503,
        message: 'The selected bank is currently unavailable',
    },
    FINAPI_PAYMENT_IDEMPOTENCY_CONFLICT: {
        code: 'FINAPI_PAYMENT_IDEMPOTENCY_CONFLICT',
        status: 409,
        message: 'A different payment with this idempotency key already exists',
    },
    FINAPI_PAYMENT_LIMIT_EXCEEDED: {
        code: 'FINAPI_PAYMENT_LIMIT_EXCEEDED',
        status: 422,
        message: 'Payment exceeds allowed limit',
    },
    FINAPI_PAYMENT_INVALID_IBAN: {
        code: 'FINAPI_PAYMENT_INVALID_IBAN',
        status: 422,
        message: 'Invalid recipient IBAN',
    },
    FINAPI_PAYMENT_INVALID_PURPOSE: {
        code: 'FINAPI_PAYMENT_INVALID_PURPOSE',
        status: 422,
        message: 'Invalid payment purpose: contains disallowed characters or exceeds 140 characters',
    },
    FINAPI_PAYMENT_FAILED: {
        code: 'FINAPI_PAYMENT_FAILED',
        status: 502,
        message: 'Payment initiation failed',
    },
    FINAPI_USER_DELETION_HAS_PENDING_PAYMENT: {
        code: 'FINAPI_USER_DELETION_HAS_PENDING_PAYMENT',
        status: 409,
        message: 'Account deletion is blocked while a finAPI payment is pending',
    },
    FINAPI_IDEMPOTENCY_KEY_MISSING: {
        code: 'FINAPI_IDEMPOTENCY_KEY_MISSING',
        status: 400,
        message: 'Idempotency-Key header is required for payment initiation',
    },
    FINAPI_IDEMPOTENCY_KEY_INVALID: {
        code: 'FINAPI_IDEMPOTENCY_KEY_INVALID',
        status: 400,
        message: 'Idempotency-Key must be 16-128 alphanumeric characters',
    },
    SPARPLAN_NOT_FOUND: {
        code: 'SPARPLAN_NOT_FOUND',
        status: 404,
        message: 'Sparplan not found',
    },
    SPARPLAN_INVALID_AMOUNT: {
        code: 'SPARPLAN_INVALID_AMOUNT',
        status: 422,
        message: 'Sparplan amount must be between the Tradevest minimum (25 EUR) and the finAPI per-transaction limit',
    },
    SPARPLAN_INVALID_DAY_OF_MONTH: {
        code: 'SPARPLAN_INVALID_DAY_OF_MONTH',
        status: 422,
        message: 'Day of month must be between 1 and 28',
    },
    SPARPLAN_UNKNOWN_ASSET: {
        code: 'SPARPLAN_UNKNOWN_ASSET',
        status: 422,
        message: 'The selected crypto asset is not available for trading',
    },
    SPARPLAN_TRADEVEST_NOT_ONBOARDED: {
        code: 'SPARPLAN_TRADEVEST_NOT_ONBOARDED',
        status: 409,
        message: 'Tradevest onboarding is required before setting up a Sparplan',
    },
    SPARPLAN_CONNECTION_NO_PIS_SCOPE: {
        code: 'SPARPLAN_CONNECTION_NO_PIS_SCOPE',
        status: 409,
        message: 'The selected bank connection does not have PIS scope; please reconnect with PIS',
    },
    SPARPLAN_SETUP_FAILED: {
        code: 'SPARPLAN_SETUP_FAILED',
        status: 502,
        message: 'finAPI rejected the Sparplan standing-order setup',
    },
    SPARPLAN_PROVIDER_MISCONFIGURED: {
        code: 'SPARPLAN_PROVIDER_MISCONFIGURED',
        status: 503,
        message: 'Der Sparplan-Anbieter ist momentan nicht korrekt konfiguriert (MANDATOR_MISCONFIGURATION). Wir kümmern uns darum — bitte später erneut versuchen oder den Support kontaktieren.',
    },
    SPARPLAN_DISABLED: {
        code: 'SPARPLAN_DISABLED',
        status: 403,
        message: 'Sparplan feature is not enabled',
    },
    SPARPLAN_USER_DELETION_HAS_PENDING_EXECUTION: {
        code: 'SPARPLAN_USER_DELETION_HAS_PENDING_EXECUTION',
        status: 409,
        message: 'Account deletion is blocked while a Sparplan auto-buy is in progress. Please wait for it to complete or contact support.',
    },
};
export const ErrorCode = Object.fromEntries(Object.entries(ERRORS).map(([key, value]) => [key, value.code]));
export function getErrorConfig(errorCode) {
    const config = Object.values(ERRORS).find(e => e.code === errorCode);
    return config || { code: 'INTERNAL_ERROR', status: 500, message: 'An error occurred' };
}
export function getErrorStatusCode(errorCode) {
    return getErrorConfig(errorCode).status;
}
export function getErrorMessage(errorCode) {
    return getErrorConfig(errorCode).message;
}
//# sourceMappingURL=errors.js.map